/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

type Props = {
    title: string
    description?: string
    image?: any
}

const Dropdown: React.FC<Props> = ({ title, description, image, children }) => {
    return (
        <>
            <div className="header-dropdown pt-6">
                <div className="dropdown-inner">
                    <div className="bg-primary py-7 pl-8 pr-12 border-t-2 rounded-md border-primary-lighter">
                        <div className="flex items-center">
                            <div className="text-left">
                                <h1 className="text-gray-100 text-xl font-semibold mb-1.5">{title}</h1>
                                <p className="text-sm text-gray-300 mb-5">{description}</p>
                                <ul className="links">
                                    {children}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Dropdown